import classNames from 'classnames';
import { forwardRef, createElement } from 'react';
import { BottomSheet as BottomSheet$1 } from 'react-spring-bottom-sheet';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var classes = {"core":"BottomSheet-module_core__2Sh3W","toolbar":"BottomSheet-module_toolbar__1kyTK","toolbarLeft":"BottomSheet-module_toolbarLeft__3EFDT","toolbarRight":"BottomSheet-module_toolbarRight__26Kez","toolbarCenter":"BottomSheet-module_toolbarCenter__zCAat"};

var BottomSheet = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/createElement(BottomSheet$1, _extends({}, props, {
    className: classNames(className, classes.core),
    ref: ref
  }));
});
BottomSheet.displayName = "BottomSheet";

var BottomSheetToolbar = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var left = _ref.left,
      title = _ref.title,
      right = _ref.right,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["left", "title", "right", "className"]);

  return /*#__PURE__*/createElement("div", _extends({}, props, {
    className: classNames(classes.toolbar, className),
    ref: ref
  }), /*#__PURE__*/createElement("div", {
    className: classes.toolbarLeft
  }, left), /*#__PURE__*/createElement("h1", {
    className: classes.toolbarCenter + " u-t4 u-mb0 u-mh8"
  }, title), /*#__PURE__*/createElement("div", {
    className: classes.toolbarRight
  }, right));
});
BottomSheetToolbar.displayName = "BottomSheetToolbar";

export { BottomSheet, BottomSheetToolbar };
//# sourceMappingURL=index.es.js.map
